'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserListNameDropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/NameDropdown.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserListNameDropdown = exports.UserListNameDropdown = function (_BcReactComponent) {
  _inherits(UserListNameDropdown, _BcReactComponent);

  function UserListNameDropdown(props) {
    _classCallCheck(this, UserListNameDropdown);

    var _this = _possibleConstructorReturn(this, (UserListNameDropdown.__proto__ || Object.getPrototypeOf(UserListNameDropdown)).call(this, props));

    _this.bindAll('handleSelect', 'handleEditButtonClick', 'renderTitle');
    _this.state = { editing: false };
    return _this;
  }

  _createClass(UserListNameDropdown, [{
    key: 'handleSelect',
    value: function handleSelect(value) {
      this.setState({ editing: false });
      this.props.handleListPropertyChange(_immutable2.default.Map({ name: value }));
    }
  }, {
    key: 'handleEditButtonClick',
    value: function handleEditButtonClick() {
      var _props = this.props,
          value = _props.value,
          listNames = _props.listNames,
          handleListPropertyChange = _props.handleListPropertyChange;


      if (!value && listNames && listNames.size > 0) {
        handleListPropertyChange(_immutable2.default.Map({ name: listNames.get(0) }));
      }

      this.setState({ editing: true });
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      var value = this.props.value;


      if (!value) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_what_kind' });
      }

      return value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          listNames = _props2.listNames;


      if (this.state.editing) {
        var options = listNames.map(function (listName) {
          return {
            label: listName,
            value: listName,
            key: listName
          };
        });

        return _react2.default.createElement(
          'div',
          { className: 'cp-user-list-name-dropdown' },
          _react2.default.createElement(
            'span',
            { id: 'list-name-dropdown-label', className: 'sr-only', htmlFor: 'list-name-dropdown' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_what_kind' })
          ),
          _react2.default.createElement(_baseDropdown.Dropdown, {
            selected: value,
            mountAsOpen: true,
            dropdownMenuId: 'list-name-dropdown',
            labelledById: 'list-name-dropdown-label',
            options: options,
            className: 'btn-block',
            testId: 'list-name-dropdown',
            handleSelect: this.handleSelect })
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-name-dropdown' },
        _react2.default.createElement(
          'div',
          { className: 'edit-trigger' },
          _react2.default.createElement(
            'h2',
            {
              className: 'list-title',
              'data-test-id': 'list-name-value' },
            this.renderTitle()
          ),
          _react2.default.createElement(
            _baseButtons.TextButton,
            {
              handleClick: this.handleEditButtonClick,
              'data-test-id': 'open-list-name-dropdown' },
            _react2.default.createElement(
              _baseScreenReaderMessage2.default,
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_list_edit_name' })
            ),
            _react2.default.createElement(_baseIcons.Pencil, { color: '' })
          )
        )
      );
    }
  }]);

  return UserListNameDropdown;
}(_baseBcReactComponent2.default);

UserListNameDropdown.propTypes = {
  value: _react.PropTypes.string,
  listNames: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string).isRequired,
  handleListPropertyChange: _react.PropTypes.func.isRequired
};

exports.default = UserListNameDropdown;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/name-dropdown/components/NameDropdown.component.js
// module id = 1324
// module chunks = 0